import Notifications from '../components/home/notifications/notifications'
import HCommerce2 from '../components/hCommerce/hCommerce2'
import viewBill2 from '../components/viewBill2/viewBill2'
import TVControl from '../components/TVControl2/TVcontrol'
import RoomControl2 from '../components/roomControl2/index'
import GuestRequest from '../components/guestRequest/guestRequest'
import HomePage from '../components/home/homePage'
import SplashScreenOverlay from '../UI/splashScreenOverlay'
import StayStep1 from '../components/autoCheckin';
import Checkin from '../components/autoCheckin/Checkin'
import StayStep2 from '../components/autoCheckin/VerifyIdentity';
import StayStep3 from '../components/autoCheckin/ConfidenceShow';
import Booking from '../components/autoCheckin/Booking';
import DemoBooking from '../components/autoCheckin/demoBooking';
import VideoCapture from '../components/autoCheckin/videoCapture';
import CheckinCameraErr from '../components/autoCheckin/Result';
import BookingSuccess from '../components/autoCheckin/BookingSuccess'
import ProfilePhoto from '../components/autoCheckin/ProfilePhoto';
import CustomLocation from '../components/hCommerce/customLocation';
import NoConnection from '../components/home/noConnection';
import ReadMsg from '../components/home/notifications/readMessage';
import WriteMsg from '../components/home/notifications/newMessage.jsx';
import RoomDoorKey from '../../UI/doorKey/roomDoor';
import DemoRoomDoorKey from '../../UI/doorKey/demoRoomDoor';
import DemoDoorCamera from '../components/roomControl2/demoDoorCamera'
import ChangeProfilePhoto from '../components/header/profilePhoto'
import MobileTv from '../components/mobileTv/mobileTv';
import HappyUnhappy from '../components/home/happyUnhappy'
import AccompanyingGuestInput from '../components/autoCheckin/accompanyingGuestInput'
import GalleryApp from '../components/galleryApp'
import TVSelect from '../components/roomControl2/InnComRoomControl/TVLift'
import OtpValidation from '../../UI/doorKey/otpValidation'
import SelectAuthOption from '../../UI/doorKey/SelectAuthOption'
import ValidationOptions from '../../UI/doorKey/validationOptions'
import GoogleMapWeb from '../components/hCommerce/googleMapWeb';
import SendNativeSMS from '../components/smsWidget/sendSMS'
import ResReservation from '../components/resReservation/resReservation'
import hotelSelctor from '../components/hotelSelector/hotelSelctor.jsx'
import listMultiSubWidget from '../../UI/widgetDisplayTypes/listMultiSubWidget.jsx'
import SpaBooking from '../components/spaBooking/spaBooking.jsx'
import SpaBookingV2 from '../components/spaBookingV2/spaBooking.jsx'
import resReservationV2 from '../components/resReservation-sevenRooms/resReservationV2.jsx'
import guestItinerary from '../components/guestItinerary/guestItinerary.jsx'
import GHA from "../components/GHA/index.jsx"
import Activities from '../components/activities/Activities.jsx'
import EventsSevenRooms from '../components/eventsSevenRooms/index.jsx'
import ExternalLink from '../components/home/ExternalLink'
import UpsellWidget from '../components/upsells/upsells.jsx'
import TheKnow from '../components/theKnow/index.jsx'
import music from '../../components/music/music.jsx'
import iframeRenderer from '../components/iframeRenderer/iframeRenderer.jsx'
import VirginBookList from '../components/theKnow/VirginBookList.jsx'
import FindStayForTheNonKnowMembers from '../components/theKnow/FindStayForTheNonKnowMembers.jsx'
import TripPlanner from '../components/tripPlanner/tripPlanner.js'
import  WayActivities  from '../components/way-activities/WayActivities.jsx'


export const routes = [
    {
        path: "/",
        component: HomePage
    },
    {
        path: "/happy",
        component: HappyUnhappy
    },
    {
        path: "/noConnection",
        component: NoConnection
    },
    {
        path: "/doorKey/roomDoorKey",
        component: RoomDoorKey
    },
    {
        path: "/splash",
        component: SplashScreenOverlay
    },
    {
        path: "/doorKey/demoRoomDoorKey",
        component: DemoRoomDoorKey
    },
    {
        path: "/roomControl/demoDoorCamera",
        component: DemoDoorCamera
    },
    {
        path: "/checkin/id",
        component: Checkin
    },
    {
        path: "/checkin/idCapture",
        component: StayStep1
    },
    {
        path: "/checkin/selfie",
        component: StayStep2
    },
    {
        path: "/checkin/confidence/verified/booking",
        component: Booking
    },
    {
        path: "/checkin/confidence/verified/demoBooking",
        component: DemoBooking
    },
    {
        path: "/checkin/confidence/verified/booking/book_success",
        component: BookingSuccess
    },
    {
        path: "/checkin/profile_photo",
        component: ProfilePhoto
    },
    {
        path: "/checkin/error",
        component: CheckinCameraErr
    },
    {
        path: "/checkin/confidence",
        component: StayStep3
    },
    {
        path: "/checkin/accompanyGuest",
        component: AccompanyingGuestInput
    },
    {
        path: "/videoCapture",
        component: VideoCapture
    },
    {
        path: "/notifications",
        component: Notifications
    },
    {
        path: "/notifications/readMsg",
        component: ReadMsg
    },
    {
        path: "/notifications/writeMsg",
        component: WriteMsg
    },
    {
        path: "/hcommerce2",
        component: HCommerce2
    },
    {
        path: "/spaBooking2",
        component: SpaBookingV2
    },
    {
        path: "/activityBooking",
        component: Activities
    },
    {
        path: "/way-activity",
        component: WayActivities
    },
    {
        path: "/eventsBooking",
        component: EventsSevenRooms
    },
    {
        path: "/resReservation",
        component: ResReservation
    },
    {
        path: "/resReservationV2",
        component: resReservationV2
    },
    {
        path: "/hcommerce2/custom_location",
        component: CustomLocation
    },
    {
        path: "/hcommerce2/custom_webmap",
        component: GoogleMapWeb
    },
    {
        path: "/smsMessage",
        component: SendNativeSMS
    },
    {
        path: "/viewBill2",
        component: viewBill2
    },
    {
        path: "/selectHotel",
        component: hotelSelctor
    },
    {
        path: "/theKnow",
        component: TheKnow
    },
    {
        path: "/TVControl2",
        component: TVControl
    },
    {
        path: "/mobileTv",
        component: MobileTv
    },
    {
        path: "/RoomControl2",
        component: RoomControl2
    },
    {
        path: "/TVLift",
        component: TVSelect
    },
    {
        path: "/myReservations",
        component: guestItinerary
    },
    {
        path: "/GuestRequest2",
        component: GuestRequest
    },
    {
        path: "/upsells",
        component: UpsellWidget
    },
    {
        path: "/MultiSubWidgetList",
        component: listMultiSubWidget
    },
    {
        path: "/change_profile_photo",
        component: ChangeProfilePhoto
    },
    {
        path: "/gallery",
        component: GalleryApp
    },
    {
        path: "/validation/options",
        component: ValidationOptions
    },
    {
        path: "/validation/step1",
        component: SelectAuthOption
    },
    {
        path: "/validation/step2",
        component: OtpValidation
    },
    {
        path: "/loyalty",
        component: GHA
    },
    {
        path:'/external-url',
        component:ExternalLink
    },
    {
        path:'/iframe-Renderer',
        component:iframeRenderer
    },
    {
        path: "/music",
        component: music
    },
    {
        path: "/tripPlanner",
        component: TripPlanner
    },
      {
        path: "/book-virgin",
        component: VirginBookList
      },
      {
        path: "/find-stay-non-theknow-members",
        component: FindStayForTheNonKnowMembers
      },
]
